import React, { useEffect, useState, createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
// Define user type
type User = {
  id: string;
  username: string;
  email: string;
  role: string;
  name: string;
};
// Mock users
const mockUsers = [{
  id: '1',
  username: 'adminmaker',
  email: 'adminmaker@example.com',
  password: 'Test@1234',
  role: 'admin',
  name: 'Admin Maker'
}, {
  id: '2',
  username: 'adminchecker',
  email: 'adminchecker@example.com',
  password: 'Test@1234',
  role: 'admin',
  name: 'Admin Checker'
}];
type AuthContextType = {
  user: User | null;
  login: (usernameOrEmail: string, password: string) => Promise<boolean>;
  logout: () => void;
  isAuthenticated: boolean;
};
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();
  // Check if user is already logged in from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error('Failed to parse stored user:', error);
        localStorage.removeItem('user');
      }
    }
  }, []);
  const login = async (usernameOrEmail: string, password: string): Promise<boolean> => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 500));
    // Find user by username or email
    const foundUser = mockUsers.find(u => (u.username === usernameOrEmail || u.email === usernameOrEmail) && u.password === password);
    if (foundUser) {
      // Create a user object without the password
      const {
        password,
        ...userWithoutPassword
      } = foundUser;
      setUser(userWithoutPassword);
      // Store user in localStorage
      localStorage.setItem('user', JSON.stringify(userWithoutPassword));
      return true;
    }
    return false;
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    navigate('/login');
  };
  return <AuthContext.Provider value={{
    user,
    login,
    logout,
    isAuthenticated: !!user
  }} data-id="element-297">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};